module.exports = __webpack_public_path__ + "static/img/wave_3.ef73397.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/wave_3.jpg
// module id = TLH+
// module chunks = 1